export default __webpack_public_path__ + "static/media/pedalera.569237cc.png";